import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles.module.scss';
import addVariants from '../../utils/addVariants/index.ts';

export const VARIANTS = ['default'];
const InputGroup = ({ variant: variants, className, children, ...props }) => (
  <div
    className={classnames(addVariants('aglmd-input-group', styles, variants), className)}
    {...props}
  >
    {children}
  </div>
);

InputGroup.propTypes = {
  /**
   * Decides the variant of the list item
   */
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(VARIANTS),
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(VARIANTS), PropTypes.bool]))
  ]),
  /**
   * Additional classnames to apply
   */
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

InputGroup.defaultProps = {
  variant: 'default',
  className: ''
};

export default InputGroup;
